<script lang="ts" setup>
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import StopInfoPipForm from "@/views/trips/components/forms/StopInfoPipForm.vue";
import { usePipStore } from "@/store/pip.store";
import { getStopVerifyTitle } from "@/utils/stopInfoTitle";
import type { RouteStopDto, TripDto, TripRouteDto } from "@/api/trips/dto/trip.dto";
import type { StopInfoPipProps } from "@/types/props";

const { t } = useI18n();

const pipStore = usePipStore();

const props = withDefaults(
  defineProps<{
    trip: TripDto;
    route: TripRouteDto;
    stop: RouteStopDto;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emits = defineEmits<{
  (e: "add"): void;
}>();

defineOptions({ inheritAttrs: false });

const title = computed<string>(() => getStopVerifyTitle(props.stop));

const pipProps = reactive<StopInfoPipProps>({
  get tripId() {
    return props.trip.id!;
  },
  get route() {
    return props.route;
  },
  get stop() {
    return props.stop;
  },
  get title() {
    return title.value;
  },
  preload: true,
  readonly: true,
});

async function addBol(): Promise<void> {
  await pipStore.open({
    component: StopInfoPipForm,
    props: pipProps,
    on: {
      save: () => emits("add"),
      close: () => pipStore.close(),
    },
  });
}
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    data-qa="add-bol-button"
    v-bind="$attrs"
    variant="flat"
    @click="addBol"
  >
    {{ t("trip.add-bol") }}
  </v-btn>
</template>

<style lang="scss" scoped></style>
